/**
 * Route plugin 
 * 
 * See more https://momentjs.com/
 * 
 * @type {{install(*, *): void}}
 */
const RoutePlugin = {

    install(app, options) {

        /**
         * Redirect to route
         */
        app.config.globalProperties.$redirect = (to='/dashboard', delay=200) => {
            if(!to.startsWith('/', 0)) {
                to = `/${to}`;
            }
            setTimeout(() => location.href = to, delay)
        }

    }
}

export default RoutePlugin;